import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import ProtectedRoute from "./ProtectedRoute";

const HOCHome = AuthRoute(lazy(() => import("../views/Home")));
const HOCAdmin = AuthRoute(lazy(() => import("../views/Administrator")));

const MainRoutes = (props) => {
  return (
    <Router history={props.history}>
      <Suspense fallback={<div>Chargement...</div>}>
        <Routes>
          <Route exact path={`/`} element={<HOCHome />} />
          <Route exact path={`/dashboard`} redirectTo="/"  />
          <Route exact path={`/tools`} redirectTo="/" />
          <Route exact path={`/meal`} redirectTo="/" />
          <Route exact path={"/sample"} redirectTo="/" />
          <Route
            exact
            path="/admin"
            element={<ProtectedRoute component={HOCAdmin} redirectTo="/" />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default MainRoutes;
